import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const rolloverValue = {
    name: 'rolloverValue',
    type: 'number',
    rules: {required: true},
    sm: 6,
}
const percentRolloverValue = {
    name: 'percentRolloverValue',
    type: 'number',
    rules: {required: true},
    sm: 6,
}

const numberOfReadingsFailure = {
    name: 'numberOfReadingsFailure',
    type: 'number',
    rules: {required: true},
    sm: 6,
}

const numberOfDaysReadingsMissing = {
    name: 'numberOfDaysReadingsMissing',
    type: 'number',
    rules: {required: true},
    sm: 6,
}

const queueEnabled = {
    name: 'queueEnabled',
    type: 'switch',
    sm: 6,
}

export const generalSettings = {
    generalSettings: {
        items: {rolloverValue, percentRolloverValue, queueEnabled},
    },
    errorsSettings: {
        title: 'errors',
        items: {numberOfReadingsFailure, numberOfDaysReadingsMissing},
    },
}

export const generalSettingsValidation = z.object({
    rolloverValue: ZodConfig.number({min: 0}).optional(),
    percentRolloverValue: ZodConfig.number({min: 0, max: 100}).optional(),
    numberOfReadingsFailure: ZodConfig.number({min: 0}).optional(),
    numberOfDaysReadingsMissing: ZodConfig.number({min: 0}).optional(),
    queueEnabled: z.boolean().optional(),
})
